import { createAction, lt, showErrorAlert } from '@mews/framework';
import { createFetchAction } from '@mews-commander/utils';
import { isThreadPosted } from '../selectors/threads';
import { MEMBER_ADDED, MEMBER_REMOVED, MEMBERS_FETCHING } from '../actionTypes';
import { fetchThreadsMembers } from './threadsApi';

export const fetchMembers = (threadId: $TSFixMe) => (dispatch: $TSFixMe) => {
    const promise = dispatch(fetchThreadsMembers([threadId]));
    return dispatch(createFetchAction(MEMBERS_FETCHING, promise, { id: threadId }));
};

export function addMember(threadId: $TSFixMe, member: $TSFixMe) {
    return (dispatch: $TSFixMe, getState: $TSFixMe, { container }: { container: () => CommanderContainer }) => {
        if (isThreadPosted(getState(), { id: threadId })) {
            container()
                .messageThreadComponent.addMembers(threadId, [member.profileId])
                .catch((error: $TSFixMe) => {
                    dispatch(memberRemoved(threadId, member.profileId));
                    showErrorAlert({ description: lt('MemberAddingError') });
                    throw error;
                })
                .then(() => dispatch(fetchMembers(threadId)));
        }
        return dispatch(memberAdded(threadId, member));
    };
}

export function memberAdded(threadId: $TSFixMe, member: $TSFixMe) {
    return createAction(MEMBER_ADDED, { threadId, member });
}

export function memberRemoved(threadId: $TSFixMe, memberProfileId: $TSFixMe) {
    return createAction(MEMBER_REMOVED, { threadId, memberProfileId });
}
